export const UncheckedSvg = (props: any) => {
  return (
    <svg
      {...props}
      width="26"
      height="24"
      viewBox="0 0 26 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8463 22C18.5107 22 23.1027 17.5228 23.1027 12C23.1027 6.47715 18.5107 2 12.8463 2C7.1818 2 2.58984 6.47715 2.58984 12C2.58984 17.5228 7.1818 22 12.8463 22Z"
        stroke={props.storke || '#3E4685'}
        strokeOpacity="0.25"
        strokeWidth="2"
      />
    </svg>
  )
}
